import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { desPlainesConfig } from "./data";

export default function DesPlainesPage() {
  return <CityPageTemplate config={desPlainesConfig} />;
}